module.exports = __webpack_public_path__ + "static/img/012.7850683.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/012.png
// module id = Ll5D
// module chunks = 0